import { render, staticRenderFns } from "./PopupAddTreatment.vue?vue&type=template&id=0d8805e4&scoped=true&"
import script from "./PopupAddTreatment.vue?vue&type=script&lang=ts&"
export * from "./PopupAddTreatment.vue?vue&type=script&lang=ts&"
import style0 from "./PopupAddTreatment.vue?vue&type=style&index=0&id=0d8805e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8805e4",
  null
  
)

export default component.exports